import { Box, Button } from '@mui/material';
import 'dayjs/locale/de';
import { useAuth } from '../../hooks/useAuth';

function Login() {
    const auth = useAuth();
    
    const login = () => {
        //auth.signIn();
    }

    return (
        <Box alignItems={'center'} justifyContent={'center'} width='100%'>  
            { auth.isAuthenticated && (<Box>You are already authenticated.</Box>)}
            { !auth.isAuthenticated && (<Button title='Login with TUI Account' onClick={e => login()}/>)}
        </Box>
    );
}

export default Login;